import ResponsiveContainer from '../../../../layouts/ResponsiveContainer'
import PredictiveSearchBar from '../../../../components/SearchBar/PredictiveSearchBar'
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useEffect, useState } from 'react';
import { cleanSearch, setSearchValue } from '../../../../redux/slices/openData/openDataSlice';
import { getIndicators, getSearchOfIndicators } from '../../../../redux/slices/openData/openDataThunk';
import { scrollToElement } from '../../../../utils/utils';
import { INDICATOR_TYPE_PROCESS, INDICATOR_TYPE_RESULTS, INDICATOR_TYPE_STRUCTURAL, LIMIT_PAGINATION_OPEN_DATA, VALID_SEARCH_REGEX } from '../../../../utils/const';
import useUrlParams from '../../../../hooks/useUrlParams';
import { FILTER_PARAMS_TO_REMOVE, SEARCH_PARAMS_TO_REMOVE } from '../../../../constants/params';
import { clearFilters, clearSelections } from '../../../../redux/slices/openData/openDataFiltersSlice';

const Search = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { getParam, updateParams, removeParams } = useUrlParams();

    const [open, setOpen] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [cleanValue, setCleanValue] = useState<boolean>(false);

    const { loadingSearch, search, errors_search } = useAppSelector((state) => state.open_data);
    const { searchValue } = useAppSelector(state => state.open_data);

    const TYPES_INDICATOR = [INDICATOR_TYPE_STRUCTURAL, INDICATOR_TYPE_PROCESS, INDICATOR_TYPE_RESULTS];

    //Sincroniza el estado local con los query params
    useEffect(() => {
        const searchParam = getParam('search') || "";
        if (searchParam) {
            dispatch(setSearchValue(searchParam));
            setCleanValue(true);
        }
    }, [location.search]);

    //Controla la apertura del dropdown de búsqueda
    useEffect(() => {
        if ((search && search.length) || loadingSearch || (errors_search && errors_search.length > 0)) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [search, loadingSearch, errors_search]);

    //Limpia el estado global al desmontar
    useEffect(() => {
        return () => {
            dispatch(cleanSearch());
        };
    }, [dispatch]);

    const onChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        dispatch(setSearchValue(value));
        setError(false);

        if (!value.trim() && getParam('search')) {
            dispatch(getIndicators({ limit: LIMIT_PAGINATION_OPEN_DATA, page: 1 }));
            setCleanValue(false);
            removeParams(SEARCH_PARAMS_TO_REMOVE);
            if (open) setOpen(false);
            return;
        }

        if (VALID_SEARCH_REGEX.test(value)) {
            value.length >= 3
                ? dispatch(getSearchOfIndicators({ search: value.trim() }))
                : dispatch(cleanSearch());
        } else {
            setError(true);
            if (open) setOpen(false);
        }
    };

    const selectSearch = ({ indicator, indicatorID, breadcrumbs }: { indicator: string; indicatorID: number; breadcrumbs: string; }) => {
        const parts = breadcrumbs.split("/").map(p => p.trim()).filter(Boolean);
        const typeIndicator = parts.find(part => TYPES_INDICATOR.some(type => type.toLowerCase() === part.toLowerCase())) || "";

        if (indicator && indicatorID) {
            dispatch(setSearchValue(indicator));
            //Limpiar la información del superfiltro
            removeParams(FILTER_PARAMS_TO_REMOVE);
            updateParams({
                search: indicator,
                indicatorID: indicatorID.toString(),
                searchMode: "true",
                type: typeIndicator,
                page: "1"
            });
            dispatch(clearFilters());
            dispatch(getIndicators({
                typeIndicator: [typeIndicator],
                indicatorId: indicatorID.toString(),
                page: 1,
                limit: 1
            }));
        }

        setOpen(false);
        setCleanValue(true);
        dispatch(cleanSearch());
        dispatch(clearSelections());
        scrollToElement("indicator-cards", -50, 1500);
    };

    const onCleanValueSearch = () => {
        dispatch(getIndicators({ page: 1, limit: LIMIT_PAGINATION_OPEN_DATA }));
        updateParams({ type: null, indicatorID: null, search: null, searchMode: null });
        dispatch(setSearchValue(""));
        dispatch(cleanSearch());
        dispatch(clearSelections());
        setCleanValue(false);
    };

    return (
        <ResponsiveContainer>
            <div className="bg-primary-100 rounded-md shadow-custom-dual border border-system-light-20 flex flex-col w-full">
                <div className="p-6">
                    <PredictiveSearchBar
                        placeholder="Buscar indicador"
                        isLoading={loadingSearch}
                        searchResults={search ?? []}
                        searchValue={searchValue}
                        isOpen={open}
                        onChange={onChangeSearch}
                        searchErrorMessage={errors_search ?? ''}
                        generalErrorMessage="Ingrese letras, números, espacios, comas o puntos válidos."
                        hasError={error}
                        setHasError={setError}
                        selectSearch={selectSearch}
                        onCleanValue={onCleanValueSearch}
                        cleanValue={cleanValue}
                        setIsOpen={setOpen}
                    />
                </div>
            </div>
        </ResponsiveContainer>
    );
};

export default Search;